import gql from 'graphql-tag';

export const updateReminderRuleMutation = gql`
  mutation updateReminderRule($reminderRule: InputUpdateReminderRule!) {
    updateReminderRule(reminderRule: $reminderRule)
  }
`;
